/**
 * @Author: Lzp <liuzp@xinlongmail.com>
 * @Date: 2021-09-29 14:27:21
 * @LastEditors: Lzp
 * @LastEditTime: 2021-09-29 14:27:21
 */

import * as request from '@/utils/request'
const BASE_URL = 'paihuo/employment'
export default {
  /**
   * getPaihuoEmploymentList
   * @description 查看列表
   * @author Lzp
   * @date 2021/9/29
   * @param {*} data
   * @returns
   */
  getPaihuoEmploymentList(data) {
    return request.get(`${BASE_URL}/list`, data)
  },

  /**
   * viewPaihuoEmployment
   * @description 详情
   * @author Lzp
   * @date 2021/9/29
   * @returns promise
   */
  viewPaihuoEmployment(data) {
    return request.get(`${BASE_URL}/view/${data}`)
  },
  
  /**
   * examinePaihuoEmployment
   * @description 审核
   * @author Lzp
   * @date 2021/9/29
   * @param {*} data
   * @returns
   */
  examinePaihuoEmployment(id, data) {
    return request.put(`${BASE_URL}/update/${id}`, data)
  }
}